<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- E100系共通部品_Steps -->
    <app-e100-steps></app-e100-steps>

    <!-- タイトル -->
    <div class="title">
      <h1>
        <label *ngIf="!confirmationFlag">イベント・お知らせ掲載申請</label>
        <label *ngIf="confirmationFlag">登録内容確認</label>
      </h1>
    </div>

    <!-- 会員主催イベント申請登録(E104) -->
    <div *ngIf="!confirmationFlag">
      <!-- 入力フォーム -->
      <form [formGroup]="e104InputForm">
        <!-- 会員主催イベント申請情報 -->
        <div class="event-information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項をご記載後、「確認画面へ進む」ボタンをクリックしてください。<br/>
              <label class="warning">【必須】の項目は必ず入力してください。【必須】項目に該当する内容がない場合は、「ｰｰｰ」を入力してください。
              </label>
              <br/>
              運営事務局の承認後に一般公開となります。項目毎の公開、非公開は以下の凡例をご参照ください。<br/>
              なお、「会員主催イベント」は掲載から3か月後、「会員からのお知らせ」は掲載から1年後削除、「分科会主催イベント」及び「分科会からのお知らせ」は年度末に削除されます。<br/>
              一度「登録する」ボタンを押すと内容の修正ができません。ご注意ください。
            </label><br/>
            <!-- 公開 -->
            <p-tag value="公開" styleClass="public-tag"></p-tag>
            …一般公開(ウェブサイト上で公開します)<br/>
            <!-- 非公開 -->
            <p-tag value="非公開" styleClass="private-tag"></p-tag>
            …公開しません
          </div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>掲載種別選択</h2>
          </div>
          <!-- イベント申請情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 掲載区分 -->
              <tr>
                <td class="item-input-name">
                  掲載種別<span class="required">【必須】</span>

                  <br/>
                  <div class="tooltip-text">
                    <i class="pi pi-info-circle tooltip"></i>
                    <div class="info-description pre-line">
                      【地方創生・SDGsに関する内容の各種告知】<br>
                      会員主催イベント：会員が主催又は共催する講演会・講習会等のイベント<br>
                      会員からのお知らせ：会員活動・成果等に関する情報<br>
                      分科会主催イベント：分科会が主催又は共催する講演会・講習会等のイベント<br>
                      分科会からのお知らせ：活動報告・成果等の情報（メンバー募集は不可）<br>

                    </div>
                  </div>


                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown [options]="getDicList(2016)" optionLabel="sp_name" optionValue="sp_code"
                              placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                              formControlName="event_kbn"
                              (onChange)="viewChange(e104InputForm.get('event_kbn'))"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('event_kbn')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>掲載内容</h2>
          </div>
          <!-- 未選択時 -->
          <p-table [value]="[{}]" styleClass="information-Form" *ngIf="0 == event_kbn">
            <ng-template pTemplate="body">
              掲載種別選択後、入力欄が表示されます。
            </ng-template>
          </p-table>
          <!-- 会員主催イベント/分科会主催イベント選択時 -->
          <p-table [value]="[{}]" styleClass="information-Form" *ngIf="1 == event_kbn || 4 == event_kbn">
            <ng-template pTemplate="body">
              <!-- 分科会 -->
              <tr *ngIf="4 == event_kbn">
                <td class="item-input-name">
                  分科会
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown [options]="organizerSubcommitteeList" optionLabel="subcommittee.theme"
                              optionValue="subcommittee.id" placeholder="選択してください" emptyMessage="　"
                              [showClear]="true"
                              styleClass="information-Form-dropdown" formControlName="subcommittee_id"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('subcommittee_id')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- タイトル -->
              <tr>
                <td class="item-input-name">
                  タイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="title"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('title')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 内容 -->
              <tr>
                <td class="item-input-name">
                  内容
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea class="information-Form-inputtext-wMax p-text-area-200"
                            formControlName="contents"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('contents')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 日時 -->
              <tr>
                <td class="item-input-name">
                  日時
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="date_and_time"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('date_and_time')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 会場 -->
              <tr>
                <td class="item-input-name">
                  会場
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="place"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('place')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 参加費 -->
              <tr>
                <td class="item-input-name">参加費</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="entry_fee"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('entry_fee')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 定員 -->
              <tr>
                <td class="item-input-name">定員</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="capacity"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('capacity')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 主催団体 -->
              <tr>
                <td class="item-input-name">主催団体</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="organizer"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('organizer')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- プログラム -->
              <tr>
                <td class="item-input-name">
                  プログラム
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea class="information-Form-inputtext-wMax p-text-area-300"
                            formControlName="program"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('program')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- イベントURL -->
              <tr>
                <td class="item-input-name">
                  イベントURL
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    リンクが設定されますので、URLのみをご記載ください。
                  </div>
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="event_page_url"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('event_page_url')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 申し込みURL -->
              <tr>
                <td class="item-input-name">
                  申し込みURL
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    リンクが設定されますので、URLのみをご記載ください。
                  </div>
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="application_page_url"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('application_page_url')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 問い合わせ先 -->
              <tr>
                <td class="item-input-name">
                  問い合わせ先<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="contact"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('contact')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- その他 -->
              <tr>
                <td class="item-input-name">
                  その他
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea class="information-Form-inputtext-wMax p-text-area-400"
                            formControlName="others"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('others')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <!-- 会員/分科会からのお知らせ選択時 -->
          <p-table [value]="[{}]" styleClass="information-Form" *ngIf="2 == event_kbn || 3 == event_kbn">
            <ng-template pTemplate="body">
              <!-- 分科会 -->
              <tr *ngIf="2 == event_kbn">
                <td class="item-input-name">
                  分科会
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown [options]="organizerSubcommitteeList" optionLabel="subcommittee.theme"
                              optionValue="subcommittee.id" placeholder="選択してください" emptyMessage="　"
                              [showClear]="true"
                              styleClass="information-Form-dropdown" formControlName="subcommittee_id"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('subcommittee_id')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- タイトル -->
              <tr>
                <td class="item-input-name">
                  タイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="title"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('title')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 内容 -->
              <tr>
                <td class="item-input-name">
                  内容
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea class="information-Form-inputtext-wMax p-text-area-200"
                            formControlName="contents"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('contents')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- お知らせURL -->
              <tr>
                <td class="item-input-name">
                  お知らせURL
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    リンクが設定されますので、URLのみをご記載ください。
                  </div>
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="event_page_url"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('event_page_url')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 問い合わせ先 -->
              <tr>
                <td class="item-input-name">
                  問い合わせ先<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="contact"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('contact')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- その他 -->
              <tr>
                <td class="item-input-name">
                  その他
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="others"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e104InputForm.get('others')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!e104InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- エラーがない場合のボタン位置統一用 -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="e104InputForm.valid">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1"
                [disabled]="!e104InputForm.valid" (click)="moveE105()"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- 会員主催イベント申請登録確認(E105) -->
    <div *ngIf="confirmationFlag">
      <!-- 会員主催イベント申請登録情報 -->
      <div class="event-information">
        <!-- 備考 -->
        <div class="note">
          下記内容でよろしければ、「登録する」ボタンを押して下さい。
        </div>

        <!-- 会員主催イベント/分科会主催イベント申請情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form" *ngIf="1 == event_kbn || 4 == event_kbn">
          <ng-template pTemplate="body">
            <!-- 掲載種別 -->
            <tr>
              <td class="item-input-name">
                掲載種別
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div *ngIf="1 == event_kbn">
                  会員主催イベント
                  <!-- {{getDicList(2016)[0]}}
                  {{e104InputForm.value.event_kbn}} -->
                </div>
                <div *ngIf="4 == event_kbn">
                  分科会主催イベント
                </div>
              </td>
            </tr>
            <!-- 分科会 -->
            <tr *ngIf="4 == event_kbn">
              <td class="item-input-name">
                分科会
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div *ngFor="let dicName of organizerSubcommitteeList">
                  <div *ngIf="e104InputForm.value.subcommittee_id == dicName.subcommittee.id">
                    {{ dicName['subcommittee']['theme'] }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- タイトル -->
            <tr>
              <td class="item-input-name">
                タイトル
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.title }}
              </td>
            </tr>
            <!-- 内容 -->
            <tr>
              <td class="item-input-name">
                内容
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.contents }}
              </td>
            </tr>
            <!-- 日時 -->
            <tr>
              <td class="item-input-name">
                日時
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.date_and_time }}
              </td>
            </tr>
            <!-- 会場 -->
            <tr>
              <td class="item-input-name">
                会場
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.place }}
              </td>
            </tr>
            <!-- 参加費 -->
            <tr>
              <td class="item-input-name">参加費</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.entry_fee }}
              </td>
            </tr>
            <!-- 定員 -->
            <tr>
              <td class="item-input-name">定員</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.capacity }}
              </td>
            </tr>
            <!-- 主催団体 -->
            <tr>
              <td class="item-input-name">主催団体</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.organizer }}
              </td>
            </tr>
            <!-- プログラム -->
            <tr>
              <td class="item-input-name">
                プログラム
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.program }}
              </td>
            </tr>
            <!-- イベントURL -->
            <tr>
              <td class="item-input-name">
                イベントURL
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.event_page_url }}
              </td>
            </tr>
            <!-- 申し込みURL -->
            <tr>
              <td class="item-input-name">
                申し込みURL
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.application_page_url }}
              </td>
            </tr>
            <!-- 問い合わせ先 -->
            <tr>
              <td class="item-input-name">
                問い合わせ先<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.contact }}
              </td>
            </tr>
            <!-- その他 -->
            <tr>
              <td class="item-input-name">
                その他
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.others }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- 会員からのお知らせ/分科会からのお知らせ申請情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form" *ngIf="2 == event_kbn || 3 == event_kbn">
          <ng-template pTemplate="body">
            <!-- 掲載種別 -->
            <tr>
              <td class="item-input-name">
                掲載種別
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div *ngIf="2 == event_kbn">
                  分科会からのお知らせ
                </div>
                <div *ngIf="3 == event_kbn">
                  会員からのお知らせ
                </div>
              </td>
            </tr>
            <!-- 分科会の場合に表示 -->
            <tr *ngIf="2 == event_kbn">
              <td class="item-input-name">
                分科会
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div *ngFor="let dicName of organizerSubcommitteeList">
                  <div *ngIf="e104InputForm.value.subcommittee_id == dicName.subcommittee.id">
                    {{ dicName['subcommittee']['theme'] }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- タイトル -->
            <tr>
              <td class="item-input-name">
                タイトル
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.title }}
              </td>
            </tr>
            <!-- 内容 -->
            <tr>
              <td class="item-input-name">
                内容
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.contents }}
              </td>
            </tr>
            <!-- お知らせURL -->
            <tr>
              <td class="item-input-name">
                お知らせURL
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.event_page_url }}
              </td>
            </tr>
            <!-- 問い合わせ先 -->
            <tr>
              <td class="item-input-name">
                問い合わせ先<span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.contact }}
              </td>
            </tr>
            <!-- その他 -->
            <tr>
              <td class="item-input-name">
                その他
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ e104InputForm.value.others }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="information-margin-height"></div>

      </div>
      <!-- 余白エリア用 -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="登録・更新する" class="button-default-size button1"
                (click)="moveE106()"></button>
        <button pButton type="button" label="修正する" class="button-default-size button2"
                (click)="moveE104()"></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
